module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductReviewList":{"averageReviewText":"{averageRating} z {starsCount}","pagination":{"button":{"ariaLabel":"Zobrazit další recenze","text":"Další recenze"}},"totalReviewers":"Tento produkt zatím nikdo nehodnotil. | Hodnotil {count} uživatel. | Hodnotili {count} uživatelé. | Hodnotilo {count} uživatelů."}}}')
  delete Component.options._Ctor
}
